// eslint-disable-next-line import/no-internal-modules
import Icon from '@insided/deprecated-preact-components/assets'
import classnames from 'classnames'
import { FunctionalComponent } from 'preact'

export interface AddWidgetButtonProps {
  visible: boolean
  nested: boolean
  onClick?: JSX.MouseEventHandler
}

/**
 * @deprecated
 *
 * We should forbid in e2e addressing classnames if they are not critical
 * for the third-party implementations and use data-qa="xxx" attributes
 */
const E2E_CLASSNAME = 'new-widget-dropdown-button'

const AddWidgetButton: FunctionalComponent<AddWidgetButtonProps> = ({
  visible,
  nested,
  onClick
}) => {
  return (
    <div
      className={classnames('add-widget-button-container', {
        'add-widget-button-container--hidden': !visible
      })}
    >
      <button
        tabIndex={0}
        onClick={onClick}
        className={classnames('add-widget-button', E2E_CLASSNAME, {
          'add-widget-button--nested': nested
        })}
      >
        <Icon icon='addWidget' />
      </button>
      <div className='add-widget-button-line' />
    </div>
  )
}

export default AddWidgetButton
